import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ServiziPage from "@/pages/ServiziPage";
import ListinoPage from "@/pages/ListinoPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import { DuoClairMark } from "@/components/DuoClairLogo";
import SilkBackground from "@/components/SilkBackground";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-obsidian flex flex-col items-center justify-center gap-4" data-testid="auth-loading">
        <DuoClairMark className="w-10 h-10 animate-pulse-gold" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">Verifica accesso…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <SilkBackground />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/conferma" element={<ConfirmationPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/listino" element={<ListinoPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/leads/:id" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0F0F11", border: "1px solid rgba(212,160,60,0.3)", color: "#E2E8F0" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
